import React, { Component } from 'react'
import axios from '../../axios'
import Alert from 'react-s-alert'
import qs from 'qs'
import {SelectPanel, MultiSelect} from "@khanacademy/react-multi-select";
import XLSX from "xlsx";
import Dropzone from "react-dropzone";


class ImportLibur extends Component {

    constructor(props) {
        super(props);
        this.state = {
            dataKelasAsal : [],
            partNonPkl : [],
            pageCount    : 0,
            currentPage  : 0,
            isButtonLoading: false,
            isLoading: false,
            kelas:'',
            file: [],
        }

        this.exportFile               = this.exportFile.bind(this)
        this.handleChange               = this.handleChange.bind(this)
        this.handleSubmit = this.handleSubmit.bind(this)
        this.handleSelectedChangedNonPKL = this.handleSelectedChangedNonPKL.bind(this)
    }

    handleDeleteFile(index) {

        const copiedStateFiles = [
            ...this.state.file
        ]

        copiedStateFiles.splice(index, 1)

        this.setState({
            file: copiedStateFiles
        })
    }

    onDrop(files) {
        const newState = this.state.file.concat(files)
        this.setState({
            file: newState
        });
    }

    handleSubmit() {
        let formData = new FormData();
        const config = {
            headers: { 'content-type': 'multipart/form-data' }
        }

        if ([]) {
            formData.append('file', this.state.file[0])
        }else{
            formData.append('file', '')
        }

        formData.append('user_id', localStorage.SISMART_USER_ID)

        const url = "libur/import"

        this.setState({ isButtonLoading: true })

        axios.post(url, formData, config)
            .then(response => {
                const result = response.data;

                if (result.success) {
                    Alert.success(result.message)
                    this.props.history.replace("/libur")
                }
                else {
                    if (Array.isArray(result.message)) {

                        result.message.map(item => {
                            Alert.error(item)
                            return true
                        })
                    }
                    else {
                        Alert.error(result.message)
                    }
                    this.setState({ isButtonLoading: false })
                }
            })

            .catch(error => {
                console.log("ERROR", error)
                Alert.error("Gagal terhubung ke server!")
                this.setState({ isButtonLoading: false })
            })
    }

    loadDataKelasAsal(){
        axios.post("/kelas")
            .then(response => {
                const result = response.data;

                if (result.success === true) {
                    this.setState({
                        dataKelasAsal: result.data,
                        isLoading: false
                    });
                } else {
                    Alert.error(result.message);
                    this.setState({ isLoading: false });
                }
            })
            .catch(error => {
                console.log(error)
            })
    }

    handleChange(event) {

        const target = event.target;
        const value  = target.value;
        const name   = target.name;

        this.setState({
            [name] : value,
        })

    }

    handleSelectedChangedNonPKL(partNonPkl) {
        this.state.kelas = partNonPkl.join(',');
        this.setState({partNonPkl});
    }

    componentDidMount() {
        this.loadDataKelasAsal();
    }

    exportFile() {

        if (this.state.kelas === '') {
            Alert.error("Kelas wajib dipilih!");return false;
        }

        let op = ["Tanggal (bulan/tanggal/tahun)", "Kelas", "Deskripsi"];
        let essay = [op]

        essay.push(["(02/11/2020)",this.state.kelas,""])
        const wb = XLSX.utils.book_new()
        const wsAll = XLSX.utils.aoa_to_sheet(essay)
        XLSX.utils.book_append_sheet(wb, wsAll, 'libur');
        XLSX.writeFile(wb, "Format Import Libur.xlsx");

    }

    render () {
        const dataSisNonPKL = this.state.dataKelasAsal.map(item => ({
            value: item.kelas_id,
            label: item.kelas_nama
        }));

        const {partNonPkl} = this.state;

        return (

            <div className="col-sm-12">
                <div className="card">
                    <div className="card-header">
                        Import Hari Libur
                    </div>
                    <div className="card-block">
                        <div className="form-group row">
                            <div className="col-md-12">
                                <label className="col-md-12 form-control-label">
                                    <strong>*Tentukan kelas mana yang anda ingin import, Lalu generate excel format</strong><br/>
                                    <strong>*Pastikan file sesuai formatnya seperti yg anda generate</strong><br/>
                                    <strong>*Gunakan tanda () untuk format tanggal nya </strong><br/>
                                </label>
                                <div className="form-group row">
                                    <label className="col-md-12 form-control-label">File Import</label>
                                    <div className="col-md-12">

                                        <Dropzone
                                            onDrop={this.onDrop.bind(this)}
                                            style={{
                                                width: "100%",
                                                height: "auto",
                                                border: "2px dashed #e9e9e9",
                                                padding: "20px 30px",
                                                color: "#888",
                                                cursor: "pointer",
                                                textAlign: "center",
                                                marginBottom: "15px"
                                            }}
                                        >
                                            Klik atau drop file disini untuk mengupload file
                                        </Dropzone>

                                        <ul>
                                            {
                                                this.state.file.map((item, index) =>
                                                    <li key={"file" + index} style={{ marginBottom: "10px" }}>
                                                        {item.name} {" "}
                                                        <button
                                                            title="Hapus"
                                                            className="btn btn-sm btn-danger"
                                                            onClick={() => this.handleDeleteFile(index)}
                                                            type="button"
                                                        >
                                                            <i className="fa fa-remove"></i>
                                                        </button>
                                                    </li>
                                                )
                                            }
                                        </ul>
                                    </div>
                                </div>
                                {
                                    this.state.isLoading ? "Memuat Data..." : (
                                        this.state.dataKelasAsal.length > 0 ? (
                                            <div className='card'>
                                                <div className="card-header">
                                                    Pilih Kelas
                                                    <button
                                                        type="button"
                                                        className="btn btn-md btn-primary pull-right"
                                                        disabled={this.state.isButtonLoading && "disabled" || this.state.kelas === '' && "disabled"}
                                                        onClick={this.handleSubmit}
                                                    >
                                                        {this.state.isButtonLoading ? "Loading" : "Import"}
                                                    </button>
                                                    {" "}
                                                    <button
                                                        className="btn btn-danger pull-right"
                                                        disabled={this.state.isLoading && "disabled"}
                                                        onClick={this.exportFile}>
                                                        {this.state.isLoading ? "Loading" : "Generate Excel Format"}
                                                    </button>
                                                </div>

                                                <SelectPanel
                                                    options={dataSisNonPKL}
                                                    onSelectedChanged={this.handleSelectedChangedNonPKL}
                                                    hasSelectAll
                                                    focusIndex={1}
                                                    selected={partNonPkl}
                                                    disableSearch={false}
                                                />
                                            </div>
                                        ) : (
                                            " "
                                        )
                                    )
                                }

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default ImportLibur;



// WEBPACK FOOTER //
// ./src/views/Libur/ImportLibur.js